module.exports = __webpack_public_path__ + "media/images/emoticons/airplane-a717bf447863ee425f3e5018d5142b23.gif";